import script from "./ContractApproval.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractApproval.vue?vue&type=script&setup=true&lang=ts"

import "./ContractApproval.vue?vue&type=style&index=0&id=71903228&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71903228"]])

export default __exports__